import React from 'react';
import '../Assets.css';

/**
 * A company (migration 062) as a chip: a coloured dot and the name - or the
 * short code where a row is crowded. Draws nothing for a device with no
 * company unless asked to say so, because in a list a blank is the honest
 * answer and a chip reading "None" is noise.
 */
export default function CompanyChip({ name, color = null, code = null, short = false, none = null, className = '' }) {
  if (!name) {
    return none ? <span className={`as-co as-co-none ${className}`.trim()}><span>{none}</span></span> : null;
  }
  return (
    <span className={`as-co ${className}`.trim()} data-color={color || undefined} title={short && code ? name : undefined}>
      <span className="as-co-dot" aria-hidden="true" />
      <span>{short && code ? code : name}</span>
    </span>
  );
}
